import script from "./Doc.vue?vue&type=script&setup=true&lang=js"
export * from "./Doc.vue?vue&type=script&setup=true&lang=js"

import "@/Assets/Css/bootstrap.min.css?vue&type=style&index=0&id=3d7a4445&scoped=true&lang=css"
import "./Doc.vue?vue&type=style&index=1&id=3d7a4445&lang=scss&scoped=true"
import "./Doc.vue?vue&type=style&index=2&id=3d7a4445&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7a4445"]])

export default __exports__